export const headCells = [
  //for zero(0) index for Trust/Customers
  [{
    id: 'id',
    label: 'Id',
    sortable: false,
    align: 'left',
    numIndex: 0,
    width: "10%",
    activeIndexOnly: true,
  },
  {
    id: 'holiday_date',
    label: 'Date',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: "30%",
    activeIndexOnly: true,
  },
  {
    id: 'holiday_title',
    label: 'Title',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: "30%",
    activeIndexOnly: true,
  }, {
    id: 'timesheet_name',
    label: 'Created By',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: "20%",
    activeIndexOnly: true,
  }, {
    id: 'timesheet_name',
    label: 'Created Date',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: "20%",
    activeIndexOnly: true,
  },
  {
    id: 'action',
    label: 'Action',
    sortable: false,
    align: 'center',
    width: "10%",
    numIndex: 0,
    activeIndexOnly: true,
  },],


]
